"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function ensureNoStartSlash(p) {
    return p.replace(/^\//, "");
}
exports.default = ensureNoStartSlash;
